import Index from './index/index.vue'
import Details from './details/index.vue'
export default {
  Index,
  Details
}
